<template>
  <div
    v-if="shouldShowRateLimit && showBannerOrCircle === 'banner'"
    data-testid="rate-limit-counter-container"
  >
    <rate-limit-counter-banner
      :credits-used="creditsUsed"
      :total-credits-available="totalCreditsAvailable"
      @click="handleRateLimitClick"
    ></rate-limit-counter-banner>
  </div>
</template>

<script>
import RateLimitCounterBanner from './RateLimitCounterBanner';
import RateLimitMixin from '@/mixins/rate-limit';

export default {
  name: 'RateLimitCounterContainer',
  components: {
    RateLimitCounterBanner,
  },
  mixins: [RateLimitMixin],
  props: {
    source: {
      type: Object,
      default: () => ({
        type: '',
        id: '',
      }),
    },
  },
  computed: {
    creditsUsed() {
      return this.rateLimitingCycleCredits - this.questionsRemaining;
    },
    totalCreditsAvailable() {
      return this.rateLimitingCycleCredits;
    },
  },
  methods: {
    handleRateLimitClick() {
      this.$analytics.events.selectedRateLimitCounter({
        source: this.source,
        creditsLeft: this.questionsRemaining,
      });

      this.$store.dispatch('ui/toggleUpsellModal', {
        show: true,
        source: {
          type: 'Rate Limit Counter',
        },
      });

      this.$analytics.events.viewedUpgradeScreen({
        source: {
          type: 'Rate Limit Counter',
        },
      });
    },
  },
};
</script>
